import {useOppsigelse} from "../../api/oppsigelser";
import LoadingSpinner from "../../components/LoadingSpinner";
import {PktAlert, PktTag,} from "@oslokommune/punkt-react";
import {useParams} from "react-router-dom";
import {InfoBox, InfoBoxItem} from "../../components/InfoBox";
import {useEffect} from "react";
import {getDocumentTitle} from "../../utils/documentTitle";
import {usePermisjonssøknadssak} from "../../api/permisjon";

export function PermisjonStatus() {
  const {id} = useParams()
  const [permisjonssøknadssak, permisjonssøknadssakResponseStatus] = usePermisjonssøknadssak(id)

  useEffect(()=> {
    document.title = getDocumentTitle("permisjon-status")
  })

  function getStatusTag() {
    if (!permisjonssøknadssak) return
    if (permisjonssøknadssak.status === 'GODKJENT') {
      return <PktTag skin={'green'} size={'small'}>Godkjent</PktTag>
    } else if (permisjonssøknadssak.status === 'AVSLÅTT') {
      return <PktTag skin={'red'} size={'small'}>Avslått</PktTag>
    } else {
      return <PktTag skin={'yellow'} size={'small'}>Under behandling</PktTag>
    }
  }


  return (
    <div className="pkt-cell pkt-cell--span12">
      <h1 className={'pkt-txt-40'}>
        Søknad om permisjon fra barnehage
      </h1>

      {permisjonssøknadssakResponseStatus === 'pending' && (
        <LoadingSpinner/>
      )}

      {permisjonssøknadssakResponseStatus === 'error'  && (
        <PktAlert skin={'error'} className={"mt-size-40"}>
          Det skjedde en feil. Vennligst prøv igjen senere.
        </PktAlert>
      )}

      {permisjonssøknadssakResponseStatus === 'ready' && (
        <InfoBox className={`mt-size-30 p-size-20`}>
          <InfoBoxItem title={'Status'}>{getStatusTag()}</InfoBoxItem>
          {permisjonssøknadssak?.merknad && (
            <InfoBoxItem title={'Informasjon fra saksbehandler'}>
              <span style={{whiteSpace: 'pre'}}>{permisjonssøknadssak.merknad}</span>
            </InfoBoxItem>
          )}
          <InfoBoxItem title={'Navn'}>{permisjonssøknadssak?.barnNavn}</InfoBoxItem>
        </InfoBox>
      )}
    </div>
  )
}

